<div
  class="min-h-screen"
  [ngStyle]="getBackgroundStyles()"
>
  <div
    class="flex flex-col h-screen overflow-hidden"
    [ngStyle]="getBackgroundStyles()"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.color]="textColor | contentBuilderColor"
  >
    <div
      id="header overflow-hidden"
      class="flex-shrink-0"
    >
      <app-block-list [blockIdList]="header"></app-block-list>
    </div>

    <div
      id="body"
      class="flex flex-1 flex-row gap-2.5 overflow-hidden px-5 py-5"
    >
      @if (!hideLeftBody) {
        <div
          id="body_left"
          class="flex-shrink-0"
        >
          <app-block-list [blockIdList]="sidebar"></app-block-list>
        </div>
      }
      <div
        id="body_right"
        class="flex-1 h-full px-5 overflow-y-auto scrollbar-hide"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
    <div class="footer">
      <app-block-list [blockIdList]="footer"></app-block-list>
    </div>
  </div>
</div>
